export default "__VITE_ASSET__CwK3bqMj__"